export default {

  //获取用户列表
  findUserList: '/bygUser/find',

  // 用户详情
  findById: '/bygUser/findById',


}



// WEBPACK FOOTER //
// ./src/api/UserM/urls.js